import {ApiContext} from '@vf/utility/ApiContextProvider/ApiContextProvider';
import React, {useContext, useEffect, useReducer} from 'react';
import config from './config';
import HolidaysManagementContext from './HolidaysManagementContext';
import {IMessage} from './HolidaysManagementContextPropTypes';
import {reducer} from './reducer';
import {actions} from './reducer';
export const initialState = {
  ...config,
};
export enum ENTITY_TYPES {
  FLOWS = 'flows',
  CUSTOMER_QUEUE_FLOWS = 'customerQueueFlows',
  QUEUES = 'queues',
  PROMPTS = 'prompts',
  NUMBERS = 'numbers',
}
const HolidaysManagementContextProvider: React.FC<React.ReactNode> = ({
  children,
}) => {
  const api = useContext(ApiContext);
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    listHolidays();
    listHolidayPrompts();
    getQueues();
    getNumbers();
    getTimezones();
  }, [api]);

  const getQueueMetadata = (queueId: string) => {
    const queue = state.queues.find((queue) => queue.Id === queueId);
    return queue;
  };
  const getEntityAttrValue = (
    type: ENTITY_TYPES,
    keyType: string,
    keyValue: string,
    returnAttr: string = null,
  ): any => {
    const item = state[type].find((o) => o[keyType] === keyValue);
    if (!item) return '';
    return returnAttr ? item[returnAttr] : item;
  };

  const listHolidays = async () => {
    dispatch({type: actions.LOADING_HOLIDAYS, payload: true});
    try {
      const holidaysList = await api.holiday.getAllHolidays();
      dispatch({type: actions.LIST, payload: {holidaysList}});
    } catch (err) {
      dispatch({type: actions.LOADING_HOLIDAYS, payload: false});
      setMsg({
        message: 'Server error while loading holidays data',
        type: 'error',
      });
    }
  };

  const listHolidayPrompts = async () => {
    dispatch({type: actions.LOADING_PROMPTS, payload: true});
    try {
      const prompts = await api.holiday.getHolidayPrompts();
      dispatch({
        type: actions.LIST_PROMPTS,
        payload: {prompts: prompts.prompts},
      });
    } catch (err) {
      dispatch({type: actions.LOADING_PROMPTS, payload: false});
      setMsg({
        message: 'Server error while loading prompts data',
        type: 'error',
      });
    }
  };

  const getQueues = async () => {
    try {
      const queues = await api.helpers.getAllQueues();
      dispatch({
        type: actions.GET_QUEUES,
        payload: {
          queues,
        },
      });
    } catch (err) {
      console.warn('Unable to load queues', err);
    }
  };
  const getNumbers = async () => {
    try {
      const numbers = await api.helpers.getAllNumbers();
      dispatch({
        type: actions.GET_NUMBERS,
        payload: {
          numbers,
        },
      });
    } catch (err) {
      console.warn('Unable to load claimed numbers', err);
    }
  };
  const getTimezones = async () => {
    try {
      const timezones = await api.helpers.getAllTimezones();
      dispatch({
        type: actions.GET_TIMEZONES,
        payload: {
          timezones,
        },
      });
    } catch (err) {
      console.warn('Unable to load timezones', err);
    }
  };

  const setMsg = (msg: IMessage) => {
    dispatch({type: actions.SET_MESSAGE, payload: {msg}});
  };

  return (
    <HolidaysManagementContext.Provider
      value={{
        ...state,
        getQueueMetadata,
        setMsg,
        getEntityAttrValue,
        listHolidays,
        listHolidayPrompts,
      }}>
      {children}
    </HolidaysManagementContext.Provider>
  );
};

export default HolidaysManagementContextProvider;
